import React, { useCallback, useLayoutEffect, useRef, useState } from "react"
import ReactDOM from "react-dom"
import {
  // @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
  Fragment as _Fragment,
  // @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
  jsx as _jsx,
  // @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
  jsxs as _jsxs,
} from "react/jsx-runtime"
import { calculatePosition } from "./helpers/position"
import usePortal from "./helpers/usePortal"
import useResizeObserver from "./helpers/useResizeObserver"

const Tooltip = ({
  rootId = "portal-root",
  className,
  content,
  place = "top",
  theme = "dark",
  offset = 10,
  children
}: any) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [coords, setCoords] = useState({ top: 0, left: 0 })
  const [arrowCoords, setArrowCords] = useState({ top: 0, left: 0 })
  const [placeTooltip, setPlaceTooltip] = useState(place)
  const tooltipRef = useRef(null)
  const arrowRef = useRef(null)
  const triggerRef = useRef(null)
  const target = usePortal(rootId)
  const updatePosition = useCallback(() => {
    if (triggerRef.current) {
      const {
        top,
        left,
        arrowTop,
        arrowLeft,
        place: newPlace,
      } = calculatePosition(triggerRef, tooltipRef, arrowRef, place, offset)
      setCoords({ top, left })
      setArrowCords({ top: arrowTop, left: arrowLeft })
      setPlaceTooltip(newPlace)
    }
  }, [place, offset, triggerRef])
  useResizeObserver(document.body, updatePosition)
  useLayoutEffect(() => {
    if (tooltipRef.current) {
      updatePosition()
    }
  }, [showTooltip, updatePosition])
  return _jsxs(
    _Fragment,
    {
      children: [
        React.cloneElement(_jsx("div", { children }, void 0), {
          onMouseEnter: () => {
            setShowTooltip(true)
          },
          onMouseLeave: () => {
            setShowTooltip(false)
          },
          "data-testid": "g-tooltip_trigger",
          ref: triggerRef,
        }),
        showTooltip && target &&
          ReactDOM.createPortal(
            _jsxs(
              "div",
              {
                className: `g-tooltip ${theme} ${className || ""}`,
                children: [
                  _jsx(
                    "div",
                    {
                      ref: tooltipRef,
                      className: `g-tooltip__container g-tooltip__container--${placeTooltip}`,
                      style: { ...coords },
                      children: _jsx(
                        "div",
                        {
                          className: "g-tooltip__inner",
                          children: content,
                        },
                        void 0
                      ),
                    },
                    void 0
                  ),
                  _jsx(
                    "div",
                    {
                      ref: arrowRef,
                      className: `g-tooltip__arrow g-tooltip__arrow--${placeTooltip}`,
                      style: { ...arrowCoords },
                    },
                    void 0
                  ),
                  _jsx(
                    "div",
                    {
                      className: `g-tooltip__arrow g-tooltip__arrow-border g-tooltip__arrow--${placeTooltip}`,
                      style: { ...arrowCoords },
                    },
                    void 0
                  ),
                ],
              },
              void 0
            ),
            target
          ),
      ],
    },
    void 0
  )
}
export default Tooltip
